<template>
  <div>
    <div class="d-flex align-center justify-end mb-4 flex-wrap">
      <activity-window-picker @changed="load" />
    </div>

    <v-text-field
      v-model="search"
      label="Search users"
      prepend-inner-icon="search"
      outlined
      dense
      hide-details
      clearable
      class="mb-4"
    />

    <v-data-table
      :headers="headers"
      :items="filteredUsers"
      :items-per-page="15"
      :loading="loading"
      item-key="researcherId"
      class="elevation-1"
      cypress-id="admin-user-activity-table"
      @click:row="openDetail"
    >
      <template #[`item.status`]="{ item }">
        <v-chip
          :color="item.status === 'ACTIVE' ? 'success' : 'grey'"
          small
          dark
        >
          {{ item.status }}
        </v-chip>
      </template>

      <template #[`item.lastActivityAt`]="{ item }">
        {{ formatDate(item.lastActivityAt) }}
      </template>

      <template #[`item.weeklyActivity`]="{ item }">
        <v-sparkline
          :value="item.weeklyActivity.map((w) => w.count)"
          :smooth="4"
          auto-draw
          height="28"
        />
      </template>
    </v-data-table>

    <user-activity-detail-panel
      v-model="detailOpen"
      :researcher-id="selectedResearcherId"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ActivityWindowPicker from '@/components/AdminPage/ActivityWindowPicker';
import UserActivityDetailPanel from '@/components/AdminPage/UserActivityDetailPanel';

export default {
  name: 'UserActivityTable',
  components: {
    ActivityWindowPicker,
    UserActivityDetailPanel,
  },
  data: () => ({
    loading: false,
    search: '',
    detailOpen: false,
    selectedResearcherId: null,
    headers: [
      { text: 'Email', value: 'email' },
      { text: 'Name', value: 'name' },
      { text: 'Status', value: 'status' },
      { text: 'Screening votes', value: 'screeningVotes' },
      { text: 'Full-text votes', value: 'fullTextVotes' },
      { text: 'Comments', value: 'comments' },
      { text: 'Extraction reports', value: 'extractionReports' },
      { text: 'Active reviews', value: 'activeReviewCount' },
      { text: 'Last activity', value: 'lastActivityAt' },
      { text: 'Activity', value: 'weeklyActivity', sortable: false },
    ],
  }),
  computed: {
    ...mapState('adminActivity', ['users']),
    filteredUsers() {
      const q = (this.search || '').toLowerCase();
      return this.users.filter(
        (u) =>
          !q ||
          u.email.toLowerCase().includes(q) ||
          u.name.toLowerCase().includes(q)
      );
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        await this.$store.dispatch('adminActivity/fetchUserActivity');
      } finally {
        this.loading = false;
      }
    },
    openDetail(row) {
      this.selectedResearcherId = row.researcherId;
      this.detailOpen = true;
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-AU', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
  },
};
</script>
